import { computed } from 'vue'
// import { useI18n } from 'vue-i18n'

export default function useDefaultSources() {
	// const { t: $t } = useI18n()

	// const defaultSources = {
	// 	thunderforest: {
	// 		serviceType: 'base',
	// 		type: 'raster',
	// 		tiles: ['https://b.tile.thunderforest.com/spinal-map/{z}/{x}/{y}.png?apikey=db5ae1f5778a448ca662554581f283c5'],
	// 		tileSize: 256,
	// 		maxzoom: 22,
	// 	},
	// 	// 'google': {
	// 	// 	'serviceType': 'base',
	// 	// 	'type': 'raster',
	// 	// 	'tiles': [ 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}' ],
	// 	// 	'tileSize': 256,
	// 	// 	'maxzoom': 6
	// 	// },
	// 	satellite: {
	// 		serviceType: 'base',
	// 		url: 'https://api.maptiler.com/tiles/satellite-v2/tiles.json?key=CKM1omtJINRKyKLUrCup',
	// 		type: 'raster',
	// 	},
	// 	maptiler_planet: {
	// 		url: 'https://api.maptiler.com/tiles/v3/tiles.json?key=CKM1omtJINRKyKLUrCup',
	// 		type: 'vector',
	// 		maxzoom: 21,
	// 	},
	// 	google: {
	// 		serviceType: 'base',
	// 		tiles: [
	// 			// "https://khms2.google.com/kh/v=950?x={x}&y={y}&z={z}"
	// 			'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
	// 		],
	// 		tileSize: 256,
	// 		type: 'raster',
	// 		maxzoom: 21,
	// 	},
	// }

	const defaultMapStyle = {
		version: 8,
		id: 'hybrid',
		name: 'Satellite Hybrid',
		sources: {
			google: {
				serviceType: 'base',
				layerIds: [
					'google',
					'tunnel',
					'path',
					'road',
					'railway',
					'admin_sub',
					'admin_country-dark',
					'admin_country',
					'road_label',
					'place_label',
					'state_label',
					'country_label',
					'continent_label',
				],
				tiles: ['https://khms3.google.com/kh/v=1012?x={x}&y={y}&z={z}'],
				type: 'raster',
			},

			maptiler_planet: {
				url: 'https://devtest.on-track.ai/tiles/v3/tiles.json',
				type: 'vector',
			},

			mapbox: {
				serviceType: 'base',
				type: 'raster',
				tiles: [
					'https://devtest.on-track.ai/tiles/satellite-v2/{z}/{x}/{y}.jpg',
				],
				tileSize: 256,
			},
		},
		layers: [
			// Custom layers
			{
				tileSize: 256,
				type: 'raster',
				serviceType: 'base',
				id: 'mapbox',
				source: 'mapbox',
				layout: {
					visibility: 'none',
				},
			},

			// Default layers
			// {
			// 	"id": "satellite",
			// 	"type": "raster",
			// 	"source": "satellite",
			// 	"minzoom": 0,
			// 	"layout": {
			// 		"visibility": "visible"
			// 	},
			// 	"paint": {
			// 		"raster-opacity": 1
			// 	},
			// 	"filter": [
			// 		"all"
			// 	]
			// },
			{
				id: 'google',
				type: 'raster',
				source: 'google',
				minzoom: 0,
				layout: {
					visibility: 'visible',
				},
				paint: {
					'raster-opacity': 1,
				},
				filter: ['all'],
			},
			{
				id: 'tunnel',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					'line-cap': 'butt',
					'line-join': 'miter',
				},
				paint: {
					'line-color': 'rgba(255, 255, 255, 0.2)',
					'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 6, 0.5, 20, 30],
					'line-dasharray': [0.28, 0.14],
				},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['==', 'brunnel', 'tunnel'],
					['in', 'class', 'motorway', 'primary', 'secondary', 'tertiary', 'trunk'],
				],
			},
			{
				id: 'path',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					'line-cap': 'square',
					'line-join': 'bevel',
				},
				paint: {
					'line-color': 'rgba(247, 247, 247, 0.33)',
					'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 14, 0.5, 20, 4],
					'line-dasharray': [1, 1],
				},
				filter: ['all', ['==', '$type', 'LineString'], ['in', 'class', 'path', 'track']],
			},
			{
				id: 'road',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 6,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
				},
				paint: {
					'line-color': {
						stops: [
							[8, 'rgba(255, 255, 255, 0.2)'],
							[14, 'rgba(255, 255, 255, 0.4)'],
							[18, 'rgba(255, 255, 255, 0.5)'],
						],
					},
					'line-width': [
						'interpolate',
						['linear'],
						['zoom'],
						5,
						['match', ['get', 'class'], ['motorway', 'motorway_link'], 1, 0],
						7,
						['match', ['get', 'class'], ['motorway', 'motorway_link'], 1.4, 0],
						8,
						['match', ['get', 'class'], ['motorway', 'motorway_link', 'primary', 'trunk'], 0.75, 0],
						9,
						['match', ['get', 'class'], ['secondary', 'tertiary'], 0.7, 1],
						10,
						['match', ['get', 'class'], ['motorway', 'motorway_link'], 1.3, 1.3],
						14,
						['match', ['get', 'class'], ['minor', 'service'], 0.5, 2.4],
					],
				},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['!in', 'class', 'rail', 'ferry', 'path', 'track'],
					['!=', 'brunnel', 'tunnel'],
				],
			},
			{
				id: 'railway',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 11,
				layout: {
					visibility: 'visible',
				},
				paint: {
					'line-color': 'rgba(179, 170, 158, 0.2)',
					'line-opacity': ['interpolate', ['linear'], ['zoom'], 11, 0.5, 16, 1.3],
				},
				filter: ['==', 'class', 'rail'],
			},
			{
				id: 'admin_sub',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				minzoom: 3,
				layout: {
					visibility: 'visible',
				},
				paint: {
					'line-color': 'rgba(194, 194, 194, 0.5)',
					'line-dasharray': [2, 1],
				},
				filter: ['in', 'admin_level', 4, 6, 8],
			},
			{
				id: 'admin_country-dark',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'visible',
				},
				paint: {
					'line-color': 'rgba(0, 0, 0, 0.51)',
					'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 3, 0.5, 21, 32],
					'line-offset': 1,
				},
				filter: ['all', ['<=', 'admin_level', 2], ['==', '$type', 'LineString']],
			},
			{
				id: 'admin_country',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'visible',
				},
				paint: {
					'line-color': 'rgba(226, 226, 226, 1)',
					'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 3, 0.5, 21, 32],
				},
				filter: ['all', ['<=', 'admin_level', 2], ['==', '$type', 'LineString']],
			},
			{
				id: 'road_label',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				layout: {
					'text-font': ['Noto Sans Regular'],
					'text-size': ['interpolate', ['linear', 0.75, 1, 0.75, 1], ['zoom'], 10, 8, 15, 9],
					// "text-field": "{name:latin}",
					'text-field': ['get', 'name'],
					'text-transform': 'none',
					'symbol-placement': 'line',
					'text-letter-spacing': 0.1,
					'text-rotation-alignment': 'map',
				},
				paint: {
					'text-color': 'rgba(255, 255, 255, 1)',
					'text-halo-color': 'rgba(43, 43, 43, 1)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', '$type', 'LineString'], ['!=', 'subclass', 'ferry']],
			},
			{
				id: 'place_label',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 3,
				maxzoom: 16,
				layout: {
					'text-font': ['Noto Sans Regular'],
					'text-size': [
						'interpolate',
						['linear', 0.5, 1, 0.5, 1],
						['zoom'],
						3,
						['match', ['get', 'class'], 'city', 11, 10],
						6,
						['match', ['get', 'class'], 'city', 14.5, 11],
						8,
						['match', ['get', 'class'], 'city', 16, 12],
						10,
						['match', ['get', 'class'], 'city', 20, 13],
					],
					// "text-field": "{name:latin}",
					'text-field': ['get', 'name'],
					'text-max-width': 10,
				},
				paint: {
					'text-color': 'rgba(255, 255, 255, 1)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'rgba(0, 0, 0, 1)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', '$type', 'Point'], ['!in', 'class', 'country', 'state']],
			},
			{
				id: 'state_label',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 3,
				maxzoom: 12,
				layout: {
					'text-font': ['Noto Sans Italic'],
					'text-size': [
						'interpolate',
						['linear', 0.75, 1, 0.75, 1],
						['zoom'],
						1,
						['step', ['get', 'rank'], 11, 1, 10, 2, 10],
						4,
						['step', ['get', 'rank'], 13, 1, 11, 2, 11],
						6,
						['step', ['get', 'rank'], 21, 1, 15, 2, 15],
						9,
						['step', ['get', 'rank'], 25, 1, 17, 2, 17],
					],
					// "text-field": "{name:latin}",
					'text-field': ['get', 'name'],
					'text-max-width': 10,
				},
				paint: {
					'text-color': 'rgba(255, 255, 255, 1)',
					'text-opacity': [
						'step',
						['zoom'],
						0,
						3,
						['case', ['<=', ['get', 'rank'], 3], 1, 0],
						8,
						['case', ['==', ['get', 'rank'], 0], 0, 1],
					],
					'text-halo-blur': 1,
					'text-halo-color': 'rgba(0, 0, 0, 1)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', '$type', 'Point'], ['in', 'class', 'state'], ['<=', 'rank', 6]],
			},
			{
				id: 'country_label',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 1,
				maxzoom: 12,
				layout: {
					'text-font': ['Noto Sans Bold'],
					'text-size': [
						'interpolate',
						['linear', 0.75, 1, 0.75, 1],
						['zoom'],
						1,
						['step', ['get', 'rank'], 13, 1, 12, 2, 12],
						4,
						['step', ['get', 'rank'], 15, 1, 14, 2, 14],
						6,
						['step', ['get', 'rank'], 23, 1, 18, 2, 18],
						9,
						['step', ['get', 'rank'], 27, 1, 22, 2, 22],
					],
					// "text-field": "{name:latin}",
					// "text-field": "{name:native}",
					'text-field': ['get', 'name'],
					'text-max-width': 10,
				},
				paint: {
					'text-color': 'rgba(255, 255, 255, 1)',
					'text-halo-blur': 1,
					'text-halo-color': 'rgba(0, 0, 0, 1)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', '$type', 'Point'], ['in', 'class', 'country']],
			},
			{
				id: 'continent_label',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				maxzoom: 1,
				layout: {
					'text-font': ['Noto Sans Bold'],
					'text-size': {
						stops: [
							[0, 12],
							[2, 13],
						],
					},
					// "text-field": "{name:latin}",
					'text-field': ['get', 'name'],
					visibility: 'visible',
					'text-justify': 'center',
					'text-transform': 'uppercase',
				},
				paint: {
					'text-color': 'rgba(255, 255, 255, 1)',
					'text-halo-blur': 1,
					'text-halo-color': 'rgba(0, 0, 0, 1)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'continent']],
			},

			// Streets
			{
				id: 'background-streets',
				type: 'background',
				layout: {
					visibility: 'none',
				},
				paint: {
					'background-color': {
						stops: [
							[6, 'hsl(47,79%,94%)'],
							[14, 'hsl(42,49%,93%)'],
						],
					},
				},
			},
			{
				id: 'landscape-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'globallandcover',
				maxzoom: 8,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': [
						'match',
						['get', 'class'],
						'crop',
						'hsl(50,67%,86%)',
						'scrub',
						'hsl(97,51%,80%)',
						'grass',
						'hsl(75,51%,85%)',
						'hsl(0,0%,100%)',
					],
					'fill-opacity': {
						stops: [
							[0, 1],
							[8, 0.1],
						],
					},
					'fill-antialias': true,
				},
				filter: ['all', ['in', 'class', 'crop', 'grass', 'scrub']],
			},
			{
				id: 'snow-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'landcover',
				maxzoom: 24,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': {
						stops: [
							[1, 'hsl(47,79%,99%)'],
							[10, 'hsl(99,99%,99%)'],
						],
					},
					'fill-opacity': {
						stops: [
							[0, 1],
							[10, 0.7],
						],
					},
					'fill-antialias': true,
				},
				filter: ['all', ['==', 'class', 'ice']],
			},
			{
				id: 'forest-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'globallandcover',
				maxzoom: 8,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': [
						'match',
						['get', 'class'],
						'forest',
						'hsl(119,38%,76%)',
						'tree',
						'hsl(99,42%,76%)',
						'hsl(0,0%,100%)',
					],
					'fill-opacity': {
						stops: [
							[1, 0.8],
							[8, 0],
						],
					},
					'fill-antialias': true,
				},
				filter: ['all', ['in', 'class', 'forest', 'tree']],
			},
			{
				id: 'aeroway_fill-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'aeroway',
				minzoom: 11,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(0,0%,93%)',
					'fill-opacity': 1,
				},
				metadata: {},
				filter: ['==', '$type', 'Polygon'],
			},
			{
				id: 'landcover-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'landcover',
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': [
						'match',
						['get', 'class'],
						'wood',
						'hsl(99,48%,77%)',
						'grass',
						'hsl(103,40%,85%)',
						'sand',
						'hsl(52,93%,89%)',
						'hsl(0,0%,100%)',
					],
					'fill-opacity': 0.5,
					'fill-antialias': false,
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'grass', 'sand', 'wood']],
			},
			{
				id: 'landuse_industrial-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'landuse',
				maxzoom: 24,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': [
						'match',
						['get', 'class'],
						['industrial'],
						'hsl(40,67%,90%)',
						'quarry',
						'hsl(32, 47%, 87%)',
						'hsl(60, 31%, 87%)',
					],
					'fill-opacity': 0.5,
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'industrial', 'quarry']],
			},
			{
				id: 'landuse_residential-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'landuse',
				maxzoom: 24,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': {
						stops: [
							[6, 'hsl(49,33%,86%)'],
							[18, 'hsl(41,30%,89%)'],
						],
					},
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'residential', 'suburbs', 'neighbourhood']],
			},
			{
				id: 'road_area_pedestrian-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(43,100%,99%)',
					'fill-opacity': 0.7,
				},
				metadata: {},
				filter: [
					'all',
					['==', '$type', 'Polygon'],
					['!has', 'brunnel'],
					['!in', 'class', 'bridge', 'pier'],
					['in', 'subclass', 'pedestrian', 'platform'],
				],
			},
			{
				id: 'landuse-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'landuse',
				minzoom: 9,
				maxzoom: 24,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': [
						'match',
						['get', 'class'],
						['school', 'college', 'university'],
						'hsl(194,52%,94%)',
						['stadium', 'pitch'],
						'hsl(94,100%,88%)',
						'hospital',
						'hsl(12,63%,94%)',
						'cemetery',
						'hsl(0,0%,88%)',
						'garages',
						'hsl(0,0%,93%)',
						'dam',
						'hsl(68,20%,79%)',
						'hsl(0,0%,100%)',
					],
					'fill-opacity': {
						stops: [
							[9, 0.25],
							[16, 1],
						],
					},
					'fill-antialias': true,
				},
				metadata: {},
				filter: [
					'all',
					[
						'in',
						'class',
						'cemetery',
						'college',
						'dam',
						'hospital',
						'garages',
						'pitch',
						'school',
						'stadium',
						'university',
					],
				],
			},
			{
				id: 'waterway_tunnel-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'waterway',
				minzoom: 14,
				layout: {
					'line-cap': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(210,73%,78%)',
					'line-width': {
						base: 1.3,
						stops: [
							[12, 0.5],
							[20, 6],
						],
					},
					'line-opacity': 0.5,
					'line-dasharray': [2, 4],
				},
				filter: ['all', ['==', 'brunnel', 'tunnel']],
			},
			{
				id: 'waterway_river-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'waterway',
				layout: {
					'line-cap': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(210,73%,78%)',
					'line-width': {
						stops: [
							[12, 0.5],
							[20, 6],
						],
					},
				},
				metadata: {},
				filter: ['all', ['!=', 'brunnel', 'tunnel']],
			},
			{
				id: 'water-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'water',
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': ['match', ['get', 'intermittent'], 1, 'hsl(205,91%,83%)', 'hsl(204,92%,75%)'],
					'fill-opacity': ['match', ['get', 'intermittent'], 1, 0.85, 1],
					'fill-antialias': true,
				},
				metadata: {},
				filter: ['all'],
			},
			{
				id: 'aeroway-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'aeroway',
				minzoom: 11,
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,100%)',
					'line-width': [
						'interpolate',
						['linear', 1],
						['zoom'],
						11,
						['match', ['get', 'class'], ['runway'], 3, 0.5],
						20,
						['match', ['get', 'class'], ['runway'], 16, 6],
					],
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'LineString']],
			},
			{
				id: 'aeroway_runway-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'aeroway',
				minzoom: 11,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(0,0%,97%)',
					'fill-opacity': 1,
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'runway']],
			},
			{
				id: 'aeroway_helipad-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'aeroway',
				minzoom: 11,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(0,0%,100%)',
					'fill-opacity': 1,
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'helipad']],
			},
			{
				id: 'ferry_line-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': {
						stops: [
							[10, 'hsl(205,61%,63%)'],
							[16, 'hsl(205,67%,47%)'],
						],
					},
					'line-width': 1.1,
					'line-dasharray': [2, 2],
				},
				filter: ['all', ['in', 'class', 'ferry']],
			},
			{
				id: 'tunnel-casing-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 4,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': [
						'match',
						['get', 'class'],
						'motorway',
						'hsl(28,72%,69%)',
						['trunk', 'primary'],
						'hsl(28,72%,69%)',
						'hsl(36,5%,80%)',
					],
					'line-width': [
						'interpolate',
						['linear', 2],
						['zoom'],
						6,
						0,
						7,
						0.5,
						10,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 0, 2.5],
							['trunk', 'primary'],
							2,
							0,
						],
						12,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 2, 6],
							['trunk', 'primary'],
							3,
							['secondary', 'tertiary'],
							2,
							['minor', 'service', 'track'],
							1,
							0.5,
						],
						14,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 5, 8],
							['trunk'],
							4,
							['primary'],
							6,
							['secondary'],
							6,
							['tertiary'],
							4,
							['minor', 'service', 'track'],
							3,
							3,
						],
						16,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							10,
							['secondary'],
							8,
							['tertiary'],
							8,
							['minor', 'service', 'track'],
							4,
							4,
						],
						20,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							26,
							['secondary'],
							26,
							['tertiary'],
							26,
							['minor', 'service', 'track'],
							18,
							18,
						],
					],
					'line-dasharray': [0.5, 0.25],
				},
				metadata: {},
				filter: [
					'all',
					['==', 'brunnel', 'tunnel'],
					[
						'!in',
						'class',
						'bridge',
						'ferry',
						'rail',
						'transit',
						'pier',
						'path',
						'aerialway',
						'motorway_construction',
						'trunk_construction',
						'primary_construction',
						'secondary_construction',
						'tertiary_construction',
						'minor_construction',
						'service_construction',
						'track_construction',
					],
				],
			},
			{
				id: 'tunnel-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 4,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': [
						'match',
						['get', 'class'],
						'motorway',
						'hsl(35,100%,76%)',
						['trunk', 'primary'],
						'hsl(48,100%,88%)',
						'hsl(0,0%,96%)',
					],
					'line-width': [
						'interpolate',
						['linear', 2],
						['zoom'],
						5,
						0,
						6,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'brunnel'], ['bridge'], 0, 1],
							['trunk', 'primary'],
							0,
							0,
						],
						10,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 0, 2.5],
							['trunk', 'primary'],
							1.5,
							1,
						],
						12,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 1, 4],
							['trunk'],
							2.5,
							['primary'],
							2.5,
							['secondary', 'tertiary'],
							1.5,
							['minor', 'service', 'track'],
							1,
							1,
						],
						14,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 5, 6],
							['trunk'],
							3,
							['primary'],
							5,
							['secondary'],
							4,
							['tertiary'],
							3,
							['minor', 'service', 'track'],
							2,
							2,
						],
						16,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							8,
							['secondary'],
							7,
							['tertiary'],
							6,
							['minor', 'service', 'track'],
							4,
							4,
						],
						20,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							24,
							['secondary'],
							24,
							['tertiary'],
							24,
							['minor', 'service', 'track'],
							16,
							16,
						],
					],
					'line-opacity': 1,
				},
				metadata: {},
				filter: [
					'all',
					['==', 'brunnel', 'tunnel'],
					[
						'!in',
						'class',
						'ferry',
						'rail',
						'transit',
						'pier',
						'bridge',
						'path',
						'aerialway',
						'motorway_construction',
						'trunk_construction',
						'primary_construction',
						'secondary_construction',
						'tertiary_construction',
						'minor_construction',
						'service_construction',
						'track_construction',
					],
				],
			},
			{
				id: 'tunnel_rail-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,73%)',
					'line-width': {
						base: 1.4,
						stops: [
							[14, 0.4],
							[15, 0.75],
							[20, 2],
						],
					},
					'line-opacity': 0.5,
				},
				metadata: {},
				filter: ['all', ['==', 'brunnel', 'tunnel'], ['in', 'class', 'rail']],
			},
			{
				id: 'tunnel_rail-hatching-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,73%)',
					'line-width': {
						base: 1.4,
						stops: [
							[14.5, 0],
							[15, 3],
							[20, 8],
						],
					},
					'line-opacity': 0.5,
					'line-dasharray': [0.2, 8],
				},
				metadata: {},
				filter: ['all', ['==', 'brunnel', 'tunnel'], ['==', 'class', 'rail']],
			},
			{
				id: 'tunnel_footway-casing-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 12,
				layout: {
					'line-cap': 'round',
					'line-join': 'miter',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,100%)',
					'line-width': {
						base: 1.2,
						stops: [
							[14, 0],
							[16, 0],
							[18, 4],
							[22, 8],
						],
					},
					'line-opacity': 1,
				},
				metadata: {},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['in', 'class', 'path', 'pedestrian'],
					['==', 'brunnel', 'tunnel'],
				],
			},
			{
				id: 'tunnel_footway-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 12,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,63%)',
					'line-width': {
						base: 1.2,
						stops: [
							[14, 0.5],
							[16, 1],
							[18, 2],
							[22, 5],
						],
					},
					'line-opacity': 0.4,
					'line-dasharray': {
						stops: [
							[14, [1, 0.5]],
							[18, [1, 0.25]],
						],
					},
				},
				metadata: {},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['in', 'class', 'path', 'pedestrian'],
					['==', 'brunnel', 'tunnel'],
				],
			},
			{
				id: 'road_area_pier-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(42,49%,93%)',
					'fill-antialias': true,
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'Polygon'], ['==', 'class', 'pier']],
			},
			{
				id: 'road_pier-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(42,49%,93%)',
					'line-width': {
						base: 1.2,
						stops: [
							[15, 1],
							[17, 4],
						],
					},
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'LineString'], ['in', 'class', 'pier']],
			},
			{
				id: 'road_area_bridge-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(42,49%,93%)',
					'fill-opacity': 0.6,
					'fill-antialias': true,
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'Polygon'], ['==', 'brunnel', 'bridge']],
			},
			{
				id: 'road_network-casing-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 4,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': [
						'match',
						['get', 'class'],
						'motorway',
						'hsl(28,72%,69%)',
						['trunk', 'primary'],
						'hsl(28,72%,69%)',
						'hsl(36,5%,80%)',
					],
					'line-width': [
						'interpolate',
						['linear', 2],
						['zoom'],
						6,
						0,
						7,
						0.5,
						10,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 0, 2.5],
							['trunk', 'primary'],
							2.4,
							0,
						],
						12,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 2, 6],
							['trunk', 'primary'],
							3,
							['secondary', 'tertiary'],
							2,
							['minor', 'service', 'track'],
							0,
							0,
						],
						14,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 5, 8],
							['trunk'],
							5,
							['primary'],
							5,
							['secondary'],
							4,
							['tertiary'],
							3,
							['minor', 'service', 'track'],
							1,
							3,
						],
						16,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							10,
							['secondary'],
							8,
							['tertiary'],
							8,
							['minor', 'service', 'track'],
							4,
							4,
						],
						20,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							26,
							['secondary'],
							26,
							['tertiary'],
							26,
							['minor', 'service', 'track'],
							18,
							18,
						],
					],
					'line-opacity': 1,
				},
				metadata: {},
				filter: [
					'all',
					['!in', 'brunnel', 'tunnel'],
					[
						'!in',
						'class',
						'bridge',
						'ferry',
						'rail',
						'transit',
						'pier',
						'path',
						'aerialway',
						'motorway_construction',
						'trunk_construction',
						'primary_construction',
						'secondary_construction',
						'tertiary_construction',
						'minor_construction',
						'service_construction',
						'track_construction',
					],
				],
			},
			{
				id: 'road_network_construction-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 4,
				layout: {
					'line-cap': 'square',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': [
						'match',
						['get', 'class'],
						'motorway_construction',
						'hsl(35,100%,76%)',
						['trunk_construction', 'primary_construction'],
						'hsl(48,100%,83%)',
						'hsl(0,0%,100%)',
					],
					'line-width': [
						'interpolate',
						['linear', 2],
						['zoom'],
						5,
						0,
						6,
						[
							'match',
							['get', 'class'],
							['motorway_construction'],
							['match', ['get', 'brunnel'], ['bridge'], 0, 1],
							['trunk_construction', 'primary_construction'],
							0,
							0,
						],
						10,
						[
							'match',
							['get', 'class'],
							['motorway_construction'],
							['match', ['get', 'ramp'], 1, 0, 2.5],
							['trunk_construction', 'primary_construction'],
							1.5,
							1,
						],
						12,
						[
							'match',
							['get', 'class'],
							['motorway_construction'],
							['match', ['get', 'ramp'], 1, 1, 4],
							['trunk_construction'],
							2.5,
							['primary_construction'],
							2.5,
							['secondary_construction', 'tertiary_construction'],
							1.5,
							['minor_construction', 'service_construction', 'track_construction'],
							1,
							1,
						],
						14,
						[
							'match',
							['get', 'class'],
							['motorway_construction'],
							['match', ['get', 'ramp'], 1, 5, 6],
							['trunk_construction'],
							3,
							['primary_construction'],
							5,
							['secondary_construction'],
							4,
							['tertiary_construction'],
							3,
							['minor_construction', 'service_construction', 'track_construction'],
							2,
							2,
						],
						16,
						[
							'match',
							['get', 'class'],
							['motorway_construction', 'trunk_construction', 'primary_construction'],
							8,
							['secondary_construction'],
							7,
							['tertiary_construction'],
							6,
							['minor_construction', 'service_construction', 'track_construction'],
							4,
							4,
						],
						20,
						[
							'match',
							['get', 'class'],
							['motorway_construction', 'trunk_construction', 'primary_construction'],
							24,
							['secondary_construction'],
							24,
							['tertiary_construction'],
							24,
							['minor_construction', 'service_construction', 'track_construction'],
							16,
							16,
						],
					],
					'line-opacity': ['case', ['==', ['get', 'brunnel'], 'tunnel'], 0.7, 1],
					'line-dasharray': [2, 2],
				},
				metadata: {},
				filter: [
					'all',
					[
						'in',
						'class',
						'motorway_construction',
						'trunk_construction',
						'primary_construction',
						'secondary_construction',
						'tertiary_construction',
						'minor_construction',
						'service_construction',
						'track_construction',
					],
				],
			},
			{
				id: 'road_network-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 4,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': [
						'match',
						['get', 'class'],
						'motorway',
						'hsl(35,100%,76%)',
						['trunk', 'primary'],
						'hsl(48,100%,83%)',
						'hsl(0,0%,96%)',
					],
					'line-width': [
						'interpolate',
						['linear', 2],
						['zoom'],
						5,
						0.5,
						6,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'brunnel'], ['bridge'], 0, 1],
							['trunk', 'primary'],
							0,
							0,
						],
						10,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 0, 2.5],
							['trunk', 'primary'],
							1.5,
							1,
						],
						12,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 1, 4],
							['trunk'],
							2.5,
							['primary'],
							2,
							['secondary', 'tertiary'],
							1.5,
							['minor', 'service', 'track'],
							0,
							1,
						],
						14,
						[
							'match',
							['get', 'class'],
							['motorway'],
							['match', ['get', 'ramp'], 1, 5, 6],
							['trunk'],
							3,
							['primary'],
							5,
							['secondary'],
							4,
							['tertiary'],
							3,
							['minor', 'service', 'track'],
							2,
							2,
						],
						16,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							8,
							['secondary'],
							7,
							['tertiary'],
							6,
							['minor', 'service', 'track'],
							4,
							4,
						],
						20,
						[
							'match',
							['get', 'class'],
							['motorway', 'trunk', 'primary'],
							24,
							['secondary'],
							24,
							['tertiary'],
							24,
							['minor', 'service', 'track'],
							16,
							16,
						],
					],
				},
				metadata: {},
				filter: [
					'all',
					['!=', 'brunnel', 'tunnel'],
					[
						'!in',
						'class',
						'ferry',
						'rail',
						'transit',
						'pier',
						'bridge',
						'path',
						'aerialway',
						'motorway_construction',
						'trunk_construction',
						'primary_construction',
						'secondary_construction',
						'tertiary_construction',
						'minor_construction',
						'service_construction',
						'track_construction',
					],
				],
			},
			{
				id: 'road_path_pedestrian-casing-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 12,
				layout: {
					'line-cap': 'round',
					'line-join': 'miter',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,100%)',
					'line-width': {
						base: 1.2,
						stops: [
							[14, 0],
							[16, 0],
							[18, 4],
							[22, 8],
						],
					},
				},
				metadata: {},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['in', 'class', 'path', 'pedestrian'],
					['!=', 'brunnel', 'tunnel'],
				],
			},
			{
				id: 'road_path_pedestrian-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 12,
				layout: {
					'line-cap': 'butt',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0, 0%, 79%)',
					'line-width': {
						base: 1.2,
						stops: [
							[14, 0.5],
							[16, 1],
							[18, 2],
							[22, 4],
						],
					},
					'line-dasharray': [1, 0.5],
				},
				metadata: {},
				filter: [
					'all',
					['==', '$type', 'LineString'],
					['in', 'class', 'path', 'pedestrian'],
					['!=', 'brunnel', 'tunnel'],
				],
			},
			{
				id: 'rail_major-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': {
						stops: [
							[8, 'hsl(0,0%,72%)'],
							[16, 'hsl(0,0%,70%)'],
						],
					},
					'line-width': {
						base: 1.4,
						stops: [
							[14, 0.4],
							[15, 0.75],
							[20, 2],
						],
					},
					'line-opacity': ['match', ['get', 'service'], 'yard', 0.5, 1],
				},
				metadata: {},
				filter: ['all', ['!in', 'brunnel', 'tunnel'], ['==', 'class', 'rail']],
			},
			{
				id: 'rail_major-hatching-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,72%)',
					'line-width': {
						base: 1.4,
						stops: [
							[14.5, 0],
							[15, 3],
							[20, 8],
						],
					},
					'line-opacity': ['match', ['get', 'service'], 'yard', 0.5, 1],
					'line-dasharray': [0.2, 9],
				},
				metadata: {},
				filter: ['all', ['!in', 'brunnel', 'tunnel'], ['==', 'class', 'rail']],
			},
			{
				id: 'rail_minor-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,73%)',
					'line-width': {
						base: 1.4,
						stops: [
							[14, 0.4],
							[15, 0.75],
							[20, 2],
						],
					},
				},
				metadata: {},
				filter: ['all', ['in', 'subclass', 'tram', 'light_rail']],
			},
			{
				id: 'rail_minor-hatching-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,73%)',
					'line-width': {
						base: 1.4,
						stops: [
							[14.5, 0],
							[15, 2],
							[20, 6],
						],
					},
					'line-dasharray': [0.2, 4],
				},
				metadata: {},
				filter: ['all', ['in', 'subclass', 'tram', 'light_rail']],
			},
			{
				id: 'building-streets',
				type: 'fill',
				source: 'maptiler_planet',
				'source-layer': 'building',
				minzoom: 13,
				maxzoom: 15,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-color': 'hsl(30,6%,73%)',
					'fill-opacity': 0.3,
					'fill-outline-color': 'hsla(35, 6%, 79%,0)',
					'fill-opacity-transition': {
						delay: 0,
						duration: 300,
					},
				},
				metadata: {},
			},
			{
				id: 'building-3d-streets',
				type: 'fill-extrusion',
				source: 'maptiler_planet',
				'source-layer': 'building',
				minzoom: 15,
				layout: {
					visibility: 'none',
				},
				paint: {
					'fill-extrusion-base': {
						type: 'identity',
						property: 'render_min_height',
					},
					'fill-extrusion-color': 'hsl(30,6%,73%)',
					'fill-extrusion-height': {
						type: 'identity',
						property: 'render_height',
					},
					'fill-extrusion-opacity': 0.25,
				},
				metadata: {},
				filter: ['all', ['!has', 'hide_3d']],
			},
			{
				id: 'aqueduct-casing-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'waterway',
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,51%)',
					'line-width': {
						base: 1.3,
						stops: [
							[14, 1],
							[20, 6],
						],
					},
				},
				filter: ['all', ['==', '$type', 'LineString'], ['==', 'brunnel', 'bridge']],
			},
			{
				id: 'aqueduct-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'waterway',
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(204,92%,75%)',
					'line-width': {
						base: 1.3,
						stops: [
							[12, 0.5],
							[20, 5],
						],
					},
				},
				filter: ['all', ['==', '$type', 'LineString'], ['==', 'brunnel', 'bridge']],
			},
			{
				id: 'cablecar-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 13,
				layout: {
					'line-cap': 'round',
					visibility: 'none',
				},
				paint: {
					'line-blur': 1,
					'line-color': 'hsl(0,0%,100%)',
					'line-width': {
						base: 1,
						stops: [
							[13, 2],
							[19, 4],
						],
					},
				},
				filter: ['==', 'class', 'aerialway'],
			},
			{
				id: 'cablecar-dash-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 13,
				layout: {
					'line-cap': 'round',
					'line-join': 'bevel',
					visibility: 'none',
				},
				paint: {
					'line-color': 'hsl(0,0%,64%)',
					'line-width': {
						base: 1,
						stops: [
							[13, 1],
							[19, 2],
						],
					},
					'line-dasharray': [2, 2],
				},
				filter: ['==', 'class', 'aerialway'],
			},
			{
				id: 'border_other-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				minzoom: 3,
				maxzoom: 13,
				layout: {
					visibility: 'none',
				},
				paint: {
					'line-color': ['match', ['get', 'maritime'], 1, 'hsla(210,52%,64%,0)', 'hsla(0,0%,60%,0.5)'],
					'line-width': {
						stops: [
							[3, 0.75],
							[4, 1.25],
							[11, 1.75],
							[18, 3],
						],
					},
					'line-dasharray': [2, 1],
				},
				filter: ['all', ['>=', 'admin_level', 3], ['==', 'maritime', 0], ['<', 'admin_level', 10]],
			},
			{
				id: 'border_disputed-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				minzoom: 0,
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-color': ['match', ['get', 'maritime'], 1, 'hsla(210,52%,64%,0)', 'hsl(0,0%,63%)'],
					'line-width': {
						stops: [
							[1, 0.5],
							[5, 1.5],
							[10, 2],
						],
					},
					'line-dasharray': [2, 2],
				},
				filter: ['all', ['<=', 'admin_level', 2], ['==', '$type', 'LineString'], ['==', 'disputed', 1]],
			},
			{
				id: 'border_country-streets',
				type: 'line',
				source: 'maptiler_planet',
				'source-layer': 'boundary',
				minzoom: 0,
				layout: {
					'line-cap': 'round',
					'line-join': 'round',
					visibility: 'none',
				},
				paint: {
					'line-blur': 0,
					'line-color': ['match', ['get', 'maritime'], 1, 'hsla(210,52%,64%,0)', 'hsl(0,0%,54%)'],
					'line-width': {
						stops: [
							[1, 0.5],
							[5, 1.5],
							[10, 2],
						],
					},
				},
				filter: ['all', ['<=', 'admin_level', 2], ['==', '$type', 'LineString'], ['==', 'disputed', 0]],
			},
			{
				id: 'waterway-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'waterway',
				minzoom: 13,
				layout: {
					'text-font': ['Roboto Italic', 'Noto Sans Italic'],
					'text-size': {
						stops: [
							[12, 8],
							[16, 14],
							[22, 20],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'symbol-spacing': 400,
					'text-max-width': 5,
					'symbol-placement': 'line',
					'text-letter-spacing': 0.2,
					'text-rotation-alignment': 'map',
				},
				paint: {
					'text-color': 'hsl(205,84%,39%)',
					'text-halo-blur': 2,
					'text-halo-color': 'hsl(202,100%,93%)',
					'text-halo-width': {
						stops: [
							[10, 1],
							[18, 2],
						],
					},
				},
				filter: ['all', ['==', '$type', 'LineString']],
			},
			{
				id: 'water_point-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'water_name',
				minzoom: 0,
				layout: {
					'text-font': ['Roboto Italic', 'Noto Sans Italic'],
					'text-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						1,
						['match', ['get', 'class'], ['ocean'], 14, 10],
						3,
						['match', ['get', 'class'], ['ocean'], 18, 14],
						9,
						['match', ['get', 'class'], ['ocean'], 22, 18],
						14,
						['match', ['get', 'class'], ['lake'], 14, ['sea'], 20, 26],
					],
					'text-field': ['concat', ['get', 'name:latin'], '\n', ['get', 'name:nonlatin']],
					visibility: 'none',
					'text-max-width': 5,
					'symbol-placement': 'point',
				},
				paint: {
					'text-color': {
						stops: [
							[1, 'hsl(203,54%,54%)'],
							[4, 'hsl(203,72%,39%)'],
						],
					},
					'text-opacity': ['step', ['zoom'], 0, 1, ['match', ['get', 'class'], ['ocean'], 1, 0], 3, 1],
					'text-halo-blur': 1,
					'text-halo-color': {
						stops: [
							[1, 'hsla(196,72%,80%,0.25)'],
							[3, 'hsla(200,100%,88%, 0.75)'],
						],
					},
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'Point'], ['has', 'name'], ['!=', 'class', 'lake']],
			},
			{
				id: 'water_line-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'water_name',
				minzoom: 0,
				layout: {
					'text-font': ['Roboto Italic', 'Noto Sans Italic'],
					'text-size': {
						stops: [
							[10, 13],
							[14, 16],
							[22, 20],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-max-width': 5,
					'symbol-placement': 'line',
					'text-letter-spacing': 0.1,
				},
				paint: {
					'text-color': 'hsl(205,84%,39%)',
					'text-halo-color': 'hsla(0, 100%, 100%, 0.45)',
					'text-halo-width': 1.5,
				},
				metadata: {},
				filter: ['all', ['==', '$type', 'LineString'], ['==', 'class', 'lake']],
			},
			{
				id: 'housenumber-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'housenumber',
				minzoom: 18,
				layout: {
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'text-size': 10,
					'text-field': '{housenumber}',
					visibility: 'none',
				},
				paint: {
					'text-color': 'hsl(0,0%,15%)',
					'text-halo-blur': 1,
					'text-halo-color': 'hsl(0,0%,98%)',
					'text-halo-width': 1,
				},
			},
			{
				id: 'gondola-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 13,
				layout: {
					'text-font': ['Roboto Italic', 'Noto Sans Italic'],
					'text-size': {
						base: 1,
						stops: [
							[13, 11],
							[15, 12],
							[18, 13],
							[22, 14],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'center',
					'text-offset': [0.8, 0.8],
					'symbol-placement': 'line',
				},
				paint: {
					'text-color': 'hsl(0,0%,40%)',
					'text-halo-blur': 1,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['in', 'subclass', 'gondola', 'cable_car']],
			},
			{
				id: 'ferry-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 12,
				layout: {
					'text-font': ['Roboto Italic', 'Noto Sans Italic'],
					'text-size': {
						base: 1,
						stops: [
							[13, 11],
							[15, 12],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'center',
					'text-offset': [0.8, 0.8],
					'symbol-placement': 'line',
				},
				paint: {
					'text-color': 'hsl(205,84%,39%)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'hsla(0, 0%, 100%, 0.15)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', 'subclass', 'ferry']],
			},
			{
				id: 'oneway-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation',
				minzoom: 16,
				layout: {
					'icon-size': {
						stops: [
							[16, 0.7],
							[18, 1],
						],
					},
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'icon-image': 'oneway',
					visibility: 'none',
					'icon-rotate': ['match', ['get', 'oneway'], 1, 90, -90],
					'icon-padding': 2,
					'symbol-spacing': 75,
					'symbol-placement': 'line',
					'icon-rotation-alignment': 'map',
				},
				paint: {
					'icon-opacity': 0.5,
				},
				filter: [
					'all',
					['has', 'oneway'],
					['in', 'class', 'motorway', 'trunk', 'primary', 'secondary', 'tertiary', 'minor', 'service'],
				],
			},
			{
				id: 'road-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 8,
				layout: {
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'text-size': {
						base: 1,
						stops: [
							[13, 10],
							[14, 11],
							[18, 13],
							[22, 15],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'center',
					'text-offset': [0, 0.15],
					'text-justify': 'center',
					'text-optional': false,
					'text-max-width': 10,
					'symbol-placement': 'line',
					'icon-keep-upright': false,
					'icon-allow-overlap': false,
					'text-allow-overlap': false,
					'icon-ignore-placement': false,
					'text-ignore-placement': false,
				},
				paint: {
					'text-color': 'hsl(19, 0%, 16%)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['!in', 'subclass', 'ferry', 'gondola', 'cable_car'], ['!in', 'class', 'service']],
			},
			{
				id: 'poi-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'poi',
				minzoom: 13,
				layout: {
					'icon-size': 1,
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'text-size': {
						stops: [
							[12, 10],
							[16, 12],
							[22, 14],
						],
					},
					'icon-image': ['coalesce', ['image', ['get', 'class']], ['image', ['get', 'subclass']], ['image', 'dot']],
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'top',
					'text-offset': [0, 0.9],
					'text-padding': 2,
					'text-max-width': 8,
					'icon-allow-overlap': false,
				},
				paint: {
					'text-color': [
						'match',
						['get', 'class'],
						['aerialway', 'bus', 'bicycle_rental', 'entrance', 'ferry_terminal', 'harbor'],
						'hsl(205, 85%, 53%)',
						['park', 'golf'],
						'hsl(82, 81%, 35%)',
						['hospital'],
						'hsl(5, 70%, 53%)',
						'hsl(17, 16%, 50%)',
					],
					'icon-opacity': [
						'step',
						['zoom'],
						0,
						15,
						[
							'match',
							['get', 'class'],
							[
								'aerialway',
								'castle',
								'cemetery',
								'diplomatic',
								'ferry_terminal',
								'golf',
								'harbor',
								'hospital',
								'stadium',
								'park',
								'place_of_worship',
								'zoo',
							],
							1,
							0,
						],
						16,
						[
							'match',
							['get', 'class'],
							[
								'castle',
								'cemetery',
								'town_hall',
								'diplomatic',
								'golf',
								'ferry_terminal',
								'hospital',
								'stadium',
								'park',
								'college',
								'university',
								'place_of_worship',
								'zoo',
								'museum',
								'school',
								'parking',
								'lodging',
							],
							1,
							0,
						],
						17,
						1,
						22,
						1,
					],
					'text-opacity': [
						'step',
						['zoom'],
						0,
						15,
						[
							'match',
							['get', 'class'],
							[
								'castle',
								'courthouse',
								'diplomatic',
								'golf',
								'ferry_terminal',
								'aerialway',
								'harbor',
								'stadium',
								'park',
								'university',
								'hospital',
								'place_of_worship',
								'zoo',
							],
							1,
							0,
						],
						16,
						[
							'match',
							['get', 'class'],
							[
								'castle',
								'cemetery',
								'town_hall',
								'diplomatic',
								'golf',
								'harbor',
								'college',
								'university',
								'ferry_terminal',
								'hospital',
								'stadium',
								'park',
								'place_of_worship',
								'zoo',
								'museum',
								'school',
								'lodging',
							],
							1,
							0,
						],
						17,
						1,
						22,
						1,
					],
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1.2,
				},
				metadata: {},
				filter: ['all', ['has', 'name'], ['!=', 'class', 'railway']],
			},
			{
				id: 'station-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'poi',
				minzoom: 13,
				layout: {
					'icon-size': {
						stops: [
							[13, 0.8],
							[18, 1],
						],
					},
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': {
						stops: [
							[13, 10],
							[16, 12],
							[22, 15],
						],
					},
					'icon-image': [
						'match',
						['get', 'subclass'],
						['station'],
						'railway',
						['subway', 'halt'],
						'subway',
						['tram_stop'],
						'tramway',
						'',
					],
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'top',
					'text-offset': [0, 1],
					'text-padding': 2,
					'text-max-width': 9,
					'text-line-height': 0.9,
					'text-letter-spacing': 0.02,
				},
				paint: {
					'text-color': 'hsl(205, 85%, 53%)',
					'icon-opacity': [
						'step',
						['zoom'],
						0,
						13,
						['match', ['get', 'subclass'], ['station'], 1, 0],
						14,
						['match', ['get', 'subclass'], ['station', 'subway'], 1, 0],
						15,
						['match', ['get', 'subclass'], ['station', 'halt', 'subway', 'tram_stop'], 1, 0],
						17,
						1,
						22,
						1,
					],
					'text-opacity': [
						'step',
						['zoom'],
						0,
						13,
						['match', ['get', 'subclass'], ['station'], 1, 0],
						14,
						['match', ['get', 'subclass'], ['station', 'subway'], 1, 0],
						15,
						['match', ['get', 'subclass'], ['station', 'subway', 'halt', 'tram_stop'], 1, 0],
						17,
						1,
						22,
						1,
					],
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1.2,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'railway'], ['has', 'name']],
			},
			{
				id: 'highway-junction-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 16,
				layout: {
					'icon-size': 1,
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'text-size': 9,
					'icon-image': 'exit_{ref_length}',
					'text-field': '{ref}',
					visibility: 'none',
					'text-offset': [0, 0.1],
					'symbol-spacing': 200,
					'symbol-z-order': 'auto',
					'symbol-placement': 'point',
					'symbol-avoid-edges': true,
					'icon-rotation-alignment': 'viewport',
					'text-rotation-alignment': 'viewport',
				},
				paint: {
					'text-color': 'hsl(0,0%,21%)',
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				filter: ['all', ['>', 'ref_length', 0], ['==', '$type', 'Point'], ['==', 'subclass', 'junction']],
			},
			{
				id: 'highway-shield-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 8,
				layout: {
					'icon-size': 1,
					'text-font': [
						'match',
						['get', 'class'],
						'motorway',
						['literal', ['Roboto Bold', 'Roboto Medium']],
						['literal', ['Roboto Medium']],
					],
					'text-size': {
						stops: [
							[8, 9],
							[12, 11],
							[18, 12],
						],
					},
					'icon-image': 'road_{ref_length}',
					'text-field': '{ref}',
					visibility: 'none',
					'text-offset': [0, 0.1],
					'text-padding': 2,
					'icon-text-fit': 'none',
					'symbol-spacing': {
						stops: [
							[10, 200],
							[18, 400],
						],
					},
					'text-transform': 'uppercase',
					'symbol-placement': 'line',
					'text-line-height': 1,
					'symbol-avoid-edges': true,
					'text-letter-spacing': 0.02,
					'icon-rotation-alignment': 'viewport',
					'text-rotation-alignment': 'viewport',
				},
				paint: {
					'text-color': 'hsl(0,0%,30%)',
					'icon-opacity': ['step', ['zoom'], 0, 8, ['match', ['get', 'class'], ['motorway'], 1, 0], 11, 1],
					'text-opacity': ['step', ['zoom'], 0, 8, ['match', ['get', 'class'], ['motorway'], 0.85, 0], 11, 1],
				},
				filter: [
					'all',
					['<=', 'ref_length', 6],
					['==', '$type', 'LineString'],
					['!in', 'network', 'us-interstate', 'us-highway', 'us-state'],
					['!in', 'class', 'path'],
				],
			},
			{
				id: 'highway-shield-us-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'transportation_name',
				minzoom: 7,
				layout: {
					'icon-size': 1.1,
					'text-font': [
						'match',
						['get', 'class'],
						'motorway',
						['literal', ['Roboto Bold', 'Noto Sans Bold']],
						['literal', ['Roboto Regular', 'Noto Sans Regular']],
					],
					'text-size': 9,
					'icon-image': '{network}_{ref_length}',
					'text-field': '{ref}',
					visibility: 'none',
					'text-offset': [0, 0.2],
					'symbol-spacing': 200,
					'symbol-placement': {
						base: 1,
						stops: [
							[7, 'point'],
							[7, 'line'],
							[8, 'line'],
						],
					},
					'symbol-avoid-edges': true,
					'icon-rotation-alignment': 'viewport',
					'text-rotation-alignment': 'viewport',
				},
				paint: {
					'text-color': ['match', ['get', 'network'], 'us-interstate', 'hsl(0,0%,100%)', 'hsl(0,0%,14%)'],
				},
				filter: [
					'all',
					['<=', 'ref_length', 6],
					['==', '$type', 'LineString'],
					['in', 'network', 'us-interstate', 'us-highway', 'us-state'],
				],
			},
			{
				id: 'place-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 4,
				layout: {
					'icon-size': {
						stops: [
							[6, 0.5],
							[8.9, 0.8],
							[9, 0],
						],
					},
					'text-font': ['Roboto Regular', 'Noto Sans Regular'],
					'text-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						3,
						11,
						8,
						13,
						11,
						[
							'match',
							['get', 'class'],
							'village',
							12,
							['suburb', 'neighbourhood', 'quarter', 'hamlet', 'isolated_dwelling'],
							9,
							'island',
							8,
							12,
						],
						16,
						[
							'match',
							['get', 'class'],
							'village',
							18,
							['suburb', 'neighbourhood', 'quarter', 'hamlet', 'isolated_dwelling'],
							15,
							'island',
							11,
							16,
						],
					],
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'bottom',
					'text-offset': [0, 0],
					'text-padding': 2,
					'icon-optional': false,
					'text-max-width': ['match', ['get', 'class'], ['island'], 6, 8],
					'text-transform': [
						'match',
						['get', 'class'],
						['suburb', 'neighborhood', 'neighbourhood', 'quarter', 'island'],
						'uppercase',
						'none',
					],
					'icon-allow-overlap': true,
					'text-letter-spacing': [
						'match',
						['get', 'class'],
						['suburb', 'neighborhood', 'neighbourhood', 'quarter', 'island'],
						0.2,
						0,
					],
				},
				paint: {
					'text-color': 'hsl(0,0%,20%)',
					'icon-opacity': 1,
					'text-opacity': [
						'step',
						['zoom'],
						1,
						8,
						['match', ['get', 'class'], ['island'], 0, 1],
						9,
						['match', ['get', 'class'], ['island'], 1, 1],
					],
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1.2,
				},
				metadata: {},
				filter: ['all', ['!in', 'class', 'continent', 'country', 'state', 'region', 'province', 'city', 'town']],
			},
			{
				id: 'airport-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'aerodrome_label',
				minzoom: 8,
				layout: {
					'icon-size': [
						'interpolate',
						['linear'],
						['zoom'],
						8,
						0.6,
						10,
						['match', ['get', 'class'], 'international', 0.8, 0.6],
						16,
						['match', ['get', 'class'], 'international', 1, 0.8],
					],
					'text-font': ['Roboto Bold', 'Noto Sans Regular'],
					'text-size': [
						'interpolate',
						['linear'],
						['zoom'],
						9,
						9,
						10,
						['match', ['get', 'class'], 'international', 10, 8],
						14,
						['match', ['get', 'class'], 'international', 13, 11],
					],
					'icon-image': ['match', ['get', 'class'], 'international', 'airport', 'airfield'],
					'text-field': {
						stops: [
							[8, '{iata}'],
							[12, '{name:latin}'],
						],
					},
					visibility: 'none',
					'text-anchor': 'top',
					'text-offset': [0, 0.8],
					'text-padding': 2,
					'text-optional': true,
					'text-max-width': 9,
					'text-line-height': 1.4,
				},
				paint: {
					'text-color': 'hsl(205, 85%, 53%)',
					'icon-opacity': 1,
					'text-halo-blur': 0,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1.2,
				},
				filter: ['all', ['has', 'iata'], ['!=', 'class', 'public']],
			},
			{
				id: 'airport_gate-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'aeroway',
				minzoom: 15,
				layout: {
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': {
						stops: [
							[15, 10],
							[22, 18],
						],
					},
					'text-field': '{ref}',
					visibility: 'none',
				},
				paint: {
					'text-color': 'hsl(0,0%,40%)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				filter: ['all', ['==', 'class', 'gate']],
			},
			{
				id: 'state-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 3,
				maxzoom: 9,
				layout: {
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': {
						stops: [
							[3, 9],
							[5, 10],
							[6, 11],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-padding': 2,
					'text-max-width': 8,
					'text-transform': 'uppercase',
					'text-letter-spacing': 0.1,
				},
				paint: {
					'text-color': 'hsl(0,0%,40%)',
					'text-opacity': [
						'step',
						['zoom'],
						0,
						3,
						['case', ['<=', ['get', 'rank'], 3], 1, 0],
						8,
						['case', ['==', ['get', 'rank'], 0], 0, 1],
					],
					'text-halo-color': 'hsla(0,0%,100%,0.75)',
					'text-halo-width': 0.8,
				},
				metadata: {},
				filter: ['all', ['in', 'class', 'state', 'province'], ['<=', 'rank', 6]],
			},
			{
				id: 'town-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 4,
				maxzoom: 16,
				layout: {
					'icon-size': {
						stops: [
							[6, 0.5],
							[14, 0.8],
						],
					},
					'text-font': {
						stops: [
							[6, ['Roboto Regular', 'Noto Sans Regular']],
							[12, ['Roboto Medium', 'Noto Sans Regular']],
						],
					},
					'text-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						6,
						['case', ['<=', ['get', 'rank'], 12], 11, 10],
						9,
						['case', ['<=', ['get', 'rank'], 15], 13, 12],
						16,
						['case', ['<=', ['get', 'rank'], 15], 22, 20],
					],
					'icon-image': {
						stops: [
							[6, 'circle'],
							[12, ' '],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'bottom',
					'text-offset': [0, 0],
					'icon-optional': false,
					'text-max-width': 8,
					'icon-allow-overlap': true,
				},
				paint: {
					'text-color': 'hsl(0,0%,20%)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'town']],
			},
			{
				id: 'city-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 4,
				maxzoom: 16,
				layout: {
					'icon-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						4,
						['case', ['==', ['get', 'capital'], 2], 1, 0.8],
						8,
						['case', ['==', ['get', 'capital'], 2], 1, 0.8],
						12.9,
						['case', ['==', ['get', 'capital'], 2], 1.2, 1],
						13,
						0,
					],
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						4,
						['case', ['<=', ['get', 'rank'], 2], 14, 12],
						8,
						['case', ['<=', ['get', 'rank'], 4], 18, 14],
						12,
						['case', ['<=', ['get', 'rank'], 4], 24, 18],
						16,
						['case', ['<=', ['get', 'rank'], 4], 32, 26],
					],
					'icon-image': ['step', ['zoom'], 'circle-stroke', 13, ''],
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-anchor': 'bottom',
					'text-offset': [0, 0],
					'icon-optional': false,
					'text-max-width': 8,
					'icon-allow-overlap': true,
				},
				paint: {
					'text-color': 'hsl(0,0%,20%)',
					'text-halo-blur': 0.5,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 0.8,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'city']],
			},
			{
				id: 'country-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				minzoom: 1,
				maxzoom: 12,
				layout: {
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': [
						'interpolate',
						['linear', 1],
						['zoom'],
						0,
						8,
						1,
						10,
						4,
						['case', ['>', ['get', 'rank'], 2], 15, 17],
						8,
						['case', ['>', ['get', 'rank'], 2], 19, 23],
					],
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-padding': 1,
					'text-max-width': {
						stops: [
							[1, 5],
							[5, 8],
						],
					},
					'text-transform': 'none',
					'text-allow-overlap': false,
					'text-letter-spacing': 0.07,
				},
				paint: {
					'text-color': 'hsl(0, 0%, 20%)',
					'text-opacity': [
						'interpolate',
						['linear', 1],
						['zoom'],
						4,
						['case', ['>', ['get', 'rank'], 4], 0, 1],
						5.9,
						['case', ['>', ['get', 'rank'], 4], 0, 1],
						6,
						['case', ['>', ['get', 'rank'], 4], 1, 1],
					],
					'text-halo-blur': 0.8,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'country'], ['has', 'iso_a2']],
			},
			{
				id: 'continent-streets',
				type: 'symbol',
				source: 'maptiler_planet',
				'source-layer': 'place',
				maxzoom: 1,
				layout: {
					'text-font': ['Roboto Medium', 'Noto Sans Regular'],
					'text-size': {
						stops: [
							[0, 12],
							[2, 13],
						],
					},
					'text-field': '{name:latin}',
					visibility: 'none',
					'text-justify': 'center',
					'text-transform': 'uppercase',
				},
				paint: {
					'text-color': 'hsl(0,0%,19%)',
					'text-halo-blur': 1,
					'text-halo-color': 'hsl(0,0%,100%)',
					'text-halo-width': 1,
				},
				metadata: {},
				filter: ['all', ['==', 'class', 'continent']],
			},
		],
		metadata: {
			'maptiler:copyright':
				'This style was generated on MapTiler Cloud. Usage outside of MapTiler Cloud requires valid MapTiler Data Package: https://www.maptiler.com/data/package/ -- please contact us.',
		},
		glyphs: 'https://devtest.on-track.ai/fonts/{fontstack}/{range}.pbf',
		bearing: 0,
		pitch: 0,
		center: [0, 0],
		zoom: 1,
	}

	const sourcesSelectOptions = computed(() => [
		{
			// title: 'Sattelite',
			// value: 'satellite',
			title: 'Google',
			value: 'google',
			layerIds: [
				// "satellite",
				'google',
				'tunnel',
				'path',
				'road',
				'railway',
				'admin_sub',
				'admin_country-dark',
				'admin_country',
				'road_label',
				'place_label',
				'state_label',
				'country_label',
				'continent_label',
			],
		},
		{
			title: 'Mapbox',
			value: 'mapbox',
			layerIds: [
				'mapbox',
				'place_label',
				'state_label',
				'country_label',
			],
		},
		{
			title: 'Streets',
			value: 'streets',
			layerIds: [
				'background-streets',
				'landscape-streets',
				'snow-streets',
				'forest-streets',
				'aeroway_fill-streets',
				'landcover-streets',
				'landuse_industrial-streets',
				'landuse_residential-streets',
				'road_area_pedestrian-streets',
				'landuse-streets',
				'waterway_tunnel-streets',
				'waterway_river-streets',
				'water-streets',
				'aeroway-streets',
				'aeroway_runway-streets',
				'aeroway_helipad-streets',
				'ferry_line-streets',
				'tunnel-casing-streets',
				'tunnel-streets',
				'tunnel_rail-streets',
				'tunnel_rail-hatching-streets',
				'tunnel_footway-casing-streets',
				'tunnel_footway-streets',
				'road_area_pier-streets',
				'road_pier-streets',
				'road_area_bridge-streets',
				'road_network-casing-streets',
				'road_network_construction-streets',
				'road_network-streets',
				'road_path_pedestrian-casing-streets',
				'road_path_pedestrian-streets',
				'rail_major-streets',
				'rail_major-hatching-streets',
				'rail_minor-streets',
				'rail_minor-hatching-streets',
				'building-streets',
				'building-3d-streets',
				'aqueduct-casing-streets',
				'aqueduct-streets',
				'cablecar-streets',
				'cablecar-dash-streets',
				'border_other-streets',
				'border_disputed-streets',
				'border_country-streets',
				'waterway-streets',
				'water_point-streets',
				'water_line-streets',
				'housenumber-streets',
				'gondola-streets',
				'ferry-streets',
				'oneway-streets',
				'road-streets',
				'poi-streets',
				'station-streets',
				'highway-junction-streets',
				'highway-shield-streets',
				'highway-shield-us-streets',
				'place-streets',
				'airport-streets',
				'airport_gate-streets',
				'state-streets',
				'town-streets',
				'city-streets',
				'country-streets',
				'continent-streets',
			],
		},
	])

	const allBaseLayersIds = computed(() => {
		return sourcesSelectOptions.value.map((item) => item.layerIds).flat()
	})

	return {
		defaultMapStyle,
		allBaseLayersIds,
		sourcesSelectOptions,
	}
}
